var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c("logo"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wtw-container account-create-container clearfix" },
        [
          _c(
            "form",
            { staticClass: "wtw-form" },
            [
              _c("h3", { staticClass: "text-center" }, [
                _vm._v("Reset Password")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-container" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.successMessage,
                        expression: "!successMessage"
                      }
                    ]
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userEmail,
                          expression: "userEmail"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|email",
                          expression: "'required|email'"
                        }
                      ],
                      class: { error: _vm.errors.has("email") },
                      attrs: {
                        type: "email",
                        name: "email",
                        placeholder: "Email"
                      },
                      domProps: { value: _vm.userEmail },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.userEmail = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("email"),
                            expression: "errors.has('email')"
                          }
                        ],
                        staticClass: "error-message"
                      },
                      [_vm._v(_vm._s(_vm.errors.first("email")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.successMessage,
                        expression: "successMessage"
                      }
                    ],
                    staticClass: "wtw-panel"
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.successMessage) +
                          "\n                    "
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("transition-group", { attrs: { name: "fade" } }, [
                !_vm.dataSending && !_vm.successMessage
                  ? _c(
                      "div",
                      {
                        key: 1,
                        staticClass: "button pink",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.sendResetEmail()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    Reset Password\n                "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSending
                  ? _c(
                      "div",
                      { key: 2, staticClass: "loading-overlay" },
                      [_c("loader")],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "back-button",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.$router.go(-1)
            }
          }
        },
        [_vm._v("\n        Back\n    ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cd45080", { render: render, staticRenderFns: staticRenderFns })
  }
}